/* eslint-disable import/no-unresolved */
const lozad = require('lozad');
const formLabelHelpers = require('../components/form');
/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad('.lozad', {
        enableAutoReload: true,
    });
    observer.observe();
}

/**
 * replaces the content in the modal window on for out of stock subscription form.
 */
function fillModalElement() {
    const outOfStockContainer = $('#out-of-stock-modal');
    let outOfStockModal = $('body > #out-of-stock-modal');

    if (!$('body > #out-of-stock-modal').length) {
        $('body').append(outOfStockContainer);
        $('.prices-add-to-cart-actions').find('#out-of-stock-modal').remove();
        outOfStockModal = $('body > #out-of-stock-modal');
    }

    // if modal exist and must be executed over another modal
    // will be reinjected (or will appear under the modal)
    if ($('body > #out-of-stock-modal').length && $('body > .modal.show').length) {
        const currentOutOfStockModal = $('body > #out-of-stock-modal');

        currentOutOfStockModal.remove();

        outOfStockContainer.appendTo('body');
    }

    outOfStockModal
        .find('.modal-body')
        .spinner()
        .start();
    triggerLozad();
    outOfStockModal.modal('show');
    formLabelHelpers.inputFocus();
    $.spinner().stop();
}

/**
 * show toast response
 * @param {Object} res - from the call to set the public status of a list or item in a list
 */
function showResponseMsg(res) {
    $.spinner().stop();
    const status = res.success ? 'alert-success' : 'alert-danger';
    const docBody = $('body');
    let outOfStockMessages = $('.out-of-stock-messages');
    let messageIcon;

    if (!outOfStockMessages.length) {
        docBody.append('<div class="out-of-stock-messages"></div>');
        outOfStockMessages = $('.out-of-stock-messages');
    }

    if (res.success) {
        messageIcon = '<span class="icon-checked-line"></span>';
    } else {
        messageIcon = '<span class="icon-alert"></span>';
    }

    outOfStockMessages.append(
        `<div class="out-of-stock-alert text-center alert ${status}">${messageIcon} ${res.subscriptiondMsgBody}</div>`,
    );

    setTimeout(() => {
        outOfStockMessages.remove();
    }, 3000);
}

function saveSubscriber(parentForm) {
    const outOfStockModal = $('#out-of-stock-modal');
    outOfStockModal
        .find('.modal-body')
        .spinner()
        .start();

    $.ajax({
        url: parentForm.attr('action'),
        type: 'POST',
        data: {
            productID: parentForm[0].productID.value,
            outOfStockSubscriber: parentForm[0].outOfStockSubscriber.value,
            productUrl: window.location.href,
        },
    }).done((response) => {
        $.spinner().stop();
        outOfStockModal.modal('hide');
        showResponseMsg(response);
    });
}

function assingClickEventAddOutofStock(docBody, error, check, mailForm) {
    docBody.off('click', '#out-of-stock-modal button.btn');
    docBody.on('click', '#out-of-stock-modal button.btn', (e) => {
        e.preventDefault();
        const $error = error.length ? error : $('#out-of-stock-modal .invalid-feedback');
        const $check = check.length ? check : $('#modal-stock-terms');
        const $mailForm = mailForm.length ? mailForm : $('.email-stock');

        if ($check.is(':checked') && $mailForm.val()) {
            const parentForm = $(e.target).parents('form');
            saveSubscriber(parentForm);
            $check.removeClass('is-invalid');
            $mailForm.removeClass('is-invalid');
            $error.hide();
        } else {
            if (!$check.is(':checked')) {
                $check.addClass('is-invalid');
            }
            if ($mailForm.val() === '') {
                $mailForm.addClass('is-invalid');
            }
            $('.is-invalid').siblings('.invalid-feedback').css('display', 'block');
        }
    });

    docBody.on('click', '#out-of-stock-modal .icon-close, .modal-backdrop', () => {
        $('.modal-backdrop').remove();
        $('body > #out-of-stock-modal').modal('hide');
    });
}

function addOutofStockInGrid() {
    const docBody = $('body');
    const error = $('#out-of-stock-modal .invalid-feedback');
    const check = $('#modal-stock-terms');
    const mailForm = $('.email-stock');
    fillModalElement();
    error.hide();
    mailForm.val('');
    assingClickEventAddOutofStock(docBody, error, check, mailForm);
}

function featuredPDPevent(pid) {
    $.ajax({
        url: $('#outofstockurl').val(),
        type: 'GET',
        data: {
            pid: pid,
        },
    }).done((response) => {
        const $outOfStockModal = $('#out-of-stock-modal');

        if ($outOfStockModal.length) {
            $outOfStockModal.remove();
            $('.modal-backdrop').remove();
        }
        $('body').append(response.htmlTemplate);
        addOutofStockInGrid();
    });
}

module.exports = {
    showOutOfStock() {
        const docBody = $('body');
        const error = $('#out-of-stock-modal .invalid-feedback');
        const check = $('#modal-stock-terms');
        const mailForm = $('.email-stock');
        const isProductSet = $('.set-items').length;

        if (!isProductSet) {
            docBody.off('click', '.outofstock-button');
            docBody.on('click', '.outofstock-button', (e) => {
                const $error = error.length ? error : $('#out-of-stock-modal .invalid-feedback');
                const $check = check.length ? check : $('#modal-stock-terms');
                const $mailForm = mailForm.length ? mailForm : $('.email-stock');

                e.preventDefault();
                fillModalElement();
                $error.hide();
                $mailForm.val('');
                $check.prop('checked', false);
            });

            assingClickEventAddOutofStock(docBody, error, check, mailForm);
        }
    },

    showOutofStockGrid(pid) {
        const page = $('.page').data('action');

        if (page !== 'Product-Show') {
            featuredPDPevent(pid);
        }
    },

    showOutofStockFeaturedPDP() {
        const docBody = $('body');
        const outOfStockButton = '.featured-product-carousel .product-tile .add-to-cart-globalGrid.outofstock';

        docBody.on('click', `.product-detail ${outOfStockButton}, #Cart-Show ${outOfStockButton}, .set-item .outofstock-button`, (e) => {
            e.preventDefault();
            const pid = $(e.currentTarget).data('pid');
            featuredPDPevent(pid);
        });
    },
};
